module.exports = __webpack_public_path__ + "static/media/zocalo16.f8df2fe6.jpg";